import {Fragment, ReactElement} from "react"
import {Form, Input, Select} from "antd"
import type {DefaultOptionType} from 'antd/es/select';
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"
import {TBoatCommon, TDictionary} from "@ui/api/user"
import {BoatInfoHeader, TBoatInfoPageProps} from "./common"

const converDictToOptions = (dict: TDictionary[], withEmptyOption: boolean = false) =>
  [
    ...(withEmptyOption ? [{label: "", value: ""}] : []),
    ...dict.map(({code, desc}) => ({label: desc, value: code}))
  ]

type TCommonItemProps = {
  prop: keyof TBoatCommon
  required?: boolean
}

type TInputItemProps = {
  maxLength: number
} & TCommonItemProps
const CommonInput = ({prop, required, maxLength}: TInputItemProps): ReactElement => {
  return (
    <Form.Item<TBoatCommon>
      label={t(`profile.boat.${prop}.title`)}
      name={prop}
      rules={[{required, message: ""}]}
    >
      <Input allowClear placeholder={t(`profile.boat.${prop}.placeholder`)} maxLength={maxLength} />
    </Form.Item>
  )
}

type TCommonSelectProps = {
  options: DefaultOptionType[]
} & TCommonItemProps
const CommonSelect = ({prop, required, options}: TCommonSelectProps): ReactElement => {
  return (
    <Form.Item<TBoatCommon>
      label={t(`profile.boat.${prop}.title`)}
      name={prop}
      rules={[{required, message: ""}]}
    >
      <Select options={options} placeholder={t(`profile.boat.${prop}.title`)} />
    </Form.Item>
  )
}

const Common = ({}: TBoatInfoPageProps): ReactElement => {
  const {dictionary: {boatTypes, boatClasses, boatCategories}} = useStore()

  return (
    <Fragment>
      <BoatInfoHeader title={t("profile.boat.info.common.header")} />
      <CommonInput prop="name" maxLength={100} />
      <CommonInput required prop="reg_number" maxLength={50} />
      <CommonSelect required options={converDictToOptions(boatTypes)} prop="boat_type" />
      <CommonSelect options={converDictToOptions(boatCategories)} prop="boat_category" />
      <CommonSelect options={converDictToOptions(boatClasses)} prop="boat_class" />
    </Fragment>
  )
}

export default Common
